<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Meeting',
  },
})

const page = {
  groupTitle: 'Rapat',
  icon: 'ri-calendar-event-line',
  color: 'teal',
  title: 'Rapat Mutu',
  description: 'Menjadwalkan rapat, mencatat kehadiran dan notulen, membuat tindak lanjut.',
  purpose: 'Panduan lengkap dari menjadwalkan rapat sampai membuat tindak lanjut hasil rapat.',
  concept: [
    {
      icon: 'ri-mail-send-line',
      title: 'Peserta Diundang Otomatis',
      text: 'Begitu Anda menjadwalkan rapat dan memilih peserta, mereka langsung menerima notifikasi undangan di dalam aplikasi — tidak perlu mengundang manual lewat WhatsApp/email.',
    },
  ],
  steps: [
    { title: 'Buka menu Rapat, klik "Jadwalkan Rapat"', detail: 'Isi Judul, Unit, Tanggal/Waktu, Lokasi, agenda, dan pilih peserta.' },
    { title: 'Klik "Simpan & Undang"', detail: 'Peserta langsung menerima notifikasi undangan.' },
    { title: 'Saat rapat berlangsung, centang peserta yang hadir', detail: 'Di halaman detail rapat, bagian Daftar Hadir.' },
    { title: 'Isi Notulen dan klik "Simpan Notulen"', detail: 'Anda juga bisa langsung menambahkan tindak lanjut (Task) sambil menyimpan notulen.' },
    { title: 'Lampirkan file pendukung (opsional)', detail: 'Mis. presentasi atau dokumen yang dibahas.' },
  ],
  tips: [
    'Tulis tindak lanjut dengan PIC dan tenggat waktu yang jelas — ini langsung jadi Task yang bisa dipantau di "Task Saya" masing-masing PIC.',
    'Bisa menambah peserta baru setelah rapat berjalan lewat tombol "Undang" di halaman detail.',
  ],
  faq: [
    { q: 'Bisakah saya mengubah notulen setelah disimpan?', a: 'Bisa — cukup buka lagi halaman detail rapat dan simpan ulang. Menambah tindak lanjut baru juga bisa dilakukan kapan saja setelah rapat, tidak harus bersamaan dengan menyimpan notulen.' },
  ],
  related: [
    { title: 'Task & Tindak Lanjut', sub: 'Menyelesaikan tindak lanjut rapat', icon: 'ri-task-line', color: 'primary', to: { name: 'help-mutu-task-tindak-lanjut' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
